import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { SharedService } from './shared/services/shared.service';
import { CommonService } from './shared/services/common.service';
import { Subscription } from 'rxjs';
import { AppSettingsResponseModel } from './shared/models/base';
export let browserRefresh = false;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    private spinnerSubscription: Subscription;
    subscription: Subscription;
    constructor(
        private primengConfig: PrimeNGConfig,
        private router: Router,
        private sharedService: SharedService,
        private common_service: CommonService
    ) {
        this.subscription = router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
              browserRefresh = !router.navigated;
              if (browserRefresh === true && this.common_service.isAuthenticated()) {
                this.loadAppSettings();
              }
            }
        });
    }

    loadAppSettings() {
        this.sharedService.getAppSettings().subscribe({
          next: (response: AppSettingsResponseModel) => {
            if (response.result === 1) {
              this.sharedService.setAppSettingValues(response.data);
            } else if (response.result === 0) {
              console.log(response.error.message[0]);
            } else {
              console.log(response.stackTrace);
            }
          },
          error: (error: any) => { },
          complete: () => { }
        });
    }
    
    ngOnInit(): void {
        this.primengConfig.ripple = true;
    }
}
